export const SET_DATA = 'mp/confirmation/SET_DATA';
export * from './selectors';

// TODO: when the endpoint is ready, replace this dummy content with an empty object
export const initialState = {
  loaded: false,
  content: {}
};

export const confirmation = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DATA:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

export default confirmation;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/confirmation/confirmation.js
 **/